import { render, staticRenderFns } from "./OrderInfoPhone.vue?vue&type=template&id=761a8139&scoped=true"
import script from "./OrderInfoPhone.vue?vue&type=script&lang=js"
export * from "./OrderInfoPhone.vue?vue&type=script&lang=js"
import style0 from "./OrderInfoPhone.vue?vue&type=style&index=0&id=761a8139&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "761a8139",
  null
  
)

export default component.exports